import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnChange(props) {
  let item = useDataValue({
    context: 'item',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'list_dialog',
    viewPath: props.viewPath,
  })

  let item_key = useDataValue({
    context: 'list_dialog',
    viewPath: props.viewPath,
    path: 'item_key',
  })

  return function onChange(value) {
    change(next => {
      if (value) {
        next.selected.push(item[item_key])
      } else {
        next.selected = next.selected.filter(id => id !== item[item_key])
      }
    })
  }
}

export function includes(selection, item, key) {
  return (selection ?? []).includes(item[key])
}
